
import Model from './Model'

export default class Combination extends Model {
  constructor (attributes = {}) {
    super(attributes.id)
    this.combination_group_id = attributes.combination_group_id // INT
    this.menu_item_id = attributes.menu_item_id // INT
    this.order = attributes.order // INT
    this.price = parseFloat(attributes.price) // DECIMAL 8,2
  }
}
